import type { FacilityCategoryEntry } from "@lib/logic";

import { HaNResultList } from "../../shared/HaNResultList/HaNResultList";
import { useOpenResult } from "../../shared/useOpenResult";
import { FacilityCategoryEntryCell } from "./FacilityCategoryEntryCell";

type FacilityCategoryEntryRowsProps = {
  entries: FacilityCategoryEntry[];
};

export const FacilityCategoryEntryRows = ({ entries }: FacilityCategoryEntryRowsProps) => {
  const openResult = useOpenResult();

  return (
    <HaNResultList>
      {entries.map(entry => {
        return (
          <HaNResultList.Item
            key={entry.id}
            nodeId={entry.id}
            onSelect={() => openResult(entry.kind, entry)}>
            <FacilityCategoryEntryCell entry={entry} />
          </HaNResultList.Item>
        );
      })}
    </HaNResultList>
  );
};
